import React from 'react'
import './loader.scss'



interface Props {
    color: string | undefined
    
}
const Loader: React.FC<Props> = ({color }) => {
    const gradientAshridgeColors = ['#0072BC', '#10B8EA', '#143c67', '#1C5592']
    const gradientGutermannColors = ['#005581', '#0079C1', '#13B5EA', '#455560']
    const colors = window.location.hostname.includes('zonelog.net') ? gradientGutermannColors : gradientAshridgeColors


    return (
        <div style={{ position: "absolute" }}>
            <div className="loader-container" style={{ background: color ? `radial-gradient(${color} 40%, transparent 70%)` : 'transparent'} }>
        
                <div className="multi-spinner-container">
                    <div className="multi-spinner" style={{ borderTopColor: colors[0], borderBottomColor: colors[1] } }>
                        <div className="multi-spinner" style={{ borderTopColor: colors[2], borderBottomColor: colors[3] }}>
                            <div className="multi-spinner" style={{ borderTopColor: colors[0], borderBottomColor: colors[1] }}>
                                <div className="multi-spinner" style={{ borderTopColor: colors[2], borderBottomColor: colors[3] }}>
                                    <div className="multi-spinner" style={{ borderTopColor: colors[0], borderBottomColor: colors[1] }}>
                                        <div className="multi-spinner" style={{ borderTopColor: colors[2], borderBottomColor: colors[3] }}>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-animation">
                    <h3 style={{ textAlign: "center", color: colors[3], marginLeft: 6 } }><b>Loading</b></h3>
                </div>
            </div>
        </div>
    )
}
export default Loader